/// <reference path="../_all.ts" />

declare var pglob : IPhotometerGlobalVar;

module solution {
  'use strict';

	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class SolutionCtrl {

    //private todos: TodoItem[];

    private depth : number; //depth of path, 2 level if application /water/turbidity/ , 1 level if industry  /beer/

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$sce',
      '$timeout',
      'anchorNavService',
      'solutionService',
      '$injector',
      'pageMetaService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: ISolutionScope
      , private $sce: ng.ISCEService
      , private $timeout : ng.ITimeoutService
      , private anchorNavService : navigation.IAnchorNavService
      , private solutionService : SolutionService
      , private $injector : ng.auto.IInjectorService
      , private pageMetaService: navigation.IPageMetaService
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      anchorNavService.subscribeOnLocationChanged($scope, (event :ng.IAngularEvent, re : IRouteEntry) => {
        this.load(re);
      });
      this.load(pglob.RouteData.RouteEntry);


      //content was edited.
      if ($injector.has("editorService")) {
        var editor : editor.IEditorService = <editor.IEditorService>$injector.get('editorService');
        editor.subscribeOnSaveContent($scope, (event: ng.IAngularEvent, filter: editor.EditorFilter, data: string) => {
          //check filter
          if (filter.FilterString1 != this.pageMetaService.getPageMeta("PageId"))  return;

          var diff :IRouteParameter[] = this.$scope.solutionData.Current.RouteParameterStack.filter((param : IRouteParameter, i: number) : boolean => {
            return param.Placeholder != filter.rpv[i].Placeholder || param.Id != filter.rpv[i].Id;
          })
          if (diff.length > 0) return; //there are differences.            

          //all ok, replace content.
          if (filter.FilterString2 === "Image") this.$scope.solutionData.Intro.ImgUrl = data;
          if (filter.FilterString2 === "Intro") this.$scope.solutionData.Intro.Text = data;
          if (filter.FilterString2 === "Schema") this.$scope.solutionData.Schema = data;
          if (filter.FilterString2 === "MeasuringTaskDescription") {            
            var group : MeasuringTaskGroup[] = this.$scope.solutionData.MeasuringTaskGroups.filter((group : MeasuringTaskGroup) => {
              return group.Id == filter.Filter3;
            })
            if (group[0]) group[0].Text = data;
          }
        });
      }

    }

    changeTopic(re : IRouteEntry, event : any, animDirectionClass? : string) {
      if (event) event.preventDefault();
      this.$scope.animDirection = animDirectionClass;
      this.anchorNavService.updateRouteParameters(re, true);
    }

    load(re : IRouteEntry) {

      var scope: ISolutionScope = this.$scope;

      var checkOverflow = () => {        
        var el: JQuery = $(".intro .content:visible");

        if (scope.expanded) {
          scope.expanded = false;
          el.on("transitionend", (e) =>  {
            if(e.target !== e.currentTarget) return;
           	el.off(e);
            this.$timeout(() => { checkOverflow(); });
          });            
        }

        var elHeight = el.prop("offsetHeight");   
        if (!elHeight) {
          this.$timeout(() => { checkOverflow(); });
          return;
        }

        var totalHeight = 0;
        var child: JQuery = el.children(":visible").each(function() {
            totalHeight = totalHeight + $(this).outerHeight(true);
        });

        if (!totalHeight) { 
          this.$timeout(() => { checkOverflow(); });
          return;
        }

        scope.overflow = totalHeight >= elHeight;    
        

      };

      
      
      scope.mtgDescEditorConfig = scope.mtgDescEditorConfig || new editor.EditorFilter();
      scope.mtgDescEditorConfig.Category = 9       
      scope.mtgDescEditorConfig.FilterString2 = "MeasuringTaskDescription";
      scope.mtgDescEditorConfig.UseRouteParam = false;
      scope.mtgDescEditorConfig.Replace = false;

      var updateGroup = (newVal: MeasuringTaskGroup) => {
        var rpv: IRouteParameter[] = pglob.RouteData.RouteEntry.RouteParameterStack;
        scope.mtgDescEditorConfig.Filter3 = newVal.Id;        
        scope.mtgDescEditorConfig.Filter1 = rpv[rpv.length - 1].Id          
        scope.mtgDescEditorConfig.Filter2 = rpv[rpv.length - 2].Id
        scope.mtgDescEditorConfig.FilterString1 = pglob.RouteData.BasePageId;    
        this.$timeout(() => { checkOverflow(); });
      }

      var selectMeasuringTask = () => {
        if (re.RouteParameterStack[0].Placeholder != "MeasuringTask") return;
        var t = scope.solutionData.MeasuringTasks.filter((mt, i, a) : boolean => {
          return mt.Id == re.RouteParameterStack[0].Id;
        });
        if (t.length == 0) return;
        var g = scope.solutionData.MeasuringTaskGroups.filter((group, i, a): boolean => {
          return group.Id == t[0].MeasuringTaskGroups[0];
        });
        if (g.length > 0) {
          scope.group = g[0];
        }
          
        scope.task = t[0];
      }

      scope.$watch('group', (newVal: MeasuringTaskGroup, oldval:MeasuringTaskGroup ) => {
        if (newVal != oldval) {
          updateGroup(newVal);
        }
      })

      this.solutionService.getSolutionData().then((data : SolutionData) => {
        scope.group = undefined;
        scope.solutionData = data;
        scope.previous = data.Previous;
        scope.next = data.Next;  
        scope.current = data.Current;  
        scope.solutionData.Schema = this.$sce.trustAsHtml(scope.solutionData.Schema)
        
        scope.group = data.MeasuringTaskGroups[0];
        selectMeasuringTask();
        updateGroup(scope.group);
        
        this.$timeout(() => { checkOverflow(); });
      });
      
    }

    scroll($event) {
      var TOPOFFSET : number = $(window).height() * 0.3; //postion element on first third

      var el : JQuery = $($event.currentTarget).closest('.overflow');

      var topPos = el.offset().top
          - parseInt(el.css("border-top-width"))
          - parseInt(el.css("margin-top"))          
          - TOPOFFSET;

      //in view -> return
      if ($(window).scrollTop() < topPos &&
          topPos < ($(window).scrollTop() + $(window).height())) return;

      this.$timeout(() => {
        (<any>$).smoothScroll(Math.round(topPos));
      }, 0);
    }


  }
}